import { z } from 'zod';
import { firestoreTimestampSchema } from './user'; // Re-use from user.ts

export const appStateSchema = z.object({
  initialized: z.boolean().optional(), // Based on sample, could be required
  createdAt: firestoreTimestampSchema,
  lastUpdated: firestoreTimestampSchema,
}).passthrough();

export type AppState = z.infer<typeof appStateSchema>;

// If there are other documents in the metadata collection,
// their schemas can be added here as well.
// For now, we only have appState.
